export const AuthApiEndpoints = {
  PASSWORD_RESET_EMAIL: '/password-reset/email',
  PASSWORD_RESET_PASSWORD: '/password-reset/password',
  LOGOUT: '/auth/logout',
};
